var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12" } },
    [
      _c(
        "v-card",
        [
          _c("v-card-text", { staticClass: "ma-1" }, [
            _vm._v("\n            " + _vm._s(_vm.salutation) + "\n        "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }